import theme from '../theme'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    '& .root__section': {
      '&--left': {
        display: 'flex',
        '& .root__select--left': {
          marginLeft: '1.5rem',
          position: 'relative',
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize + 'px !important',
          top: '-8px',
          '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    '& .root__section__resume': {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
    },
  },
  paginator: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
  },
})

export default useStyles
